var exports = module.exports = {};

exports.getSubject = function(conceptsMap, conceptId) {
  if (!conceptsMap) return null;
  var currentConcept = conceptsMap[conceptId];
  if (!currentConcept.upperConcept || !conceptsMap[currentConcept.upperConcept]) {
    return currentConcept;
  }
  else return exports.getSubject(conceptsMap, currentConcept.upperConcept);
}

exports.windowReload = function() {
  window.location.reload(true);
}

exports.convertToHtml = function (text) {
  if (text.indexOf('\n') < 0) return text
  var convertArray = text.split(/\n/)
  convertArray = convertArray.map(function(item) {
    if (item === "") item = "<br/>"
    return "<p>" + item + "</p>"
  })
  return convertArray.join("")
}


/** WEBPACK FOOTER **
 ** ./src/utils/helpers.js
 **/